/*
 * Copyright (c) 2022-2022. Revo Digital
 * ---
 * Author: gabrielecavallo
 * File: ActiveCompanySelect.tsx
 * Project: mle-client-n
 * Committed last: 2022/11/22 @ 166
 * ---
 * Description:
 */

import {observer} from 'mobx-react';
import {Button, MenuItem} from '@blueprintjs/core';
import {ItemRenderer, Select} from '@blueprintjs/select';
import {MyLabelCompanyMeta} from '../../../../entities';
import {useCallback, useEffect, useState} from 'react';
import {HasEditor} from '../../../../common/props';
import {mlAuthSecured} from '../../../../store/features/mylabel/auth/MyLabelAuthFeature';
import {mleDomainGqlClient} from '../../../../api/domain';
import {GET_COMPANIES_META, GET_COMPANY_META} from '../../../../api/domain/queries.gql';

const CompanySelect = Select.ofType<MyLabelCompanyMeta>();

interface Props extends HasEditor {
  onCompanySelect: (company: MyLabelCompanyMeta) => void;
}

export const ActiveCompanySelect = observer((props: Props) => {
  const [isLoading, setIsLoading] = useState(false);
  const [companies, setCompanies] = useState<MyLabelCompanyMeta[]>([]);
  const [selectedCompany, setSelectedCompany] = useState<MyLabelCompanyMeta>();

  const companyItemRenderer: ItemRenderer<MyLabelCompanyMeta> = (item, {
    handleClick,
    index
  }) => {
    return (
      <MenuItem text={ item.name } key={ item.id }
                onClick={ handleClick }/>
    );
  };

  useEffect(() => {
      (async () => {
        setIsLoading(true);
        // Load companies meta
        const companiesMeta = await mlAuthSecured<MyLabelCompanyMeta[]>(props.editor,
          async () => {
            return (await mleDomainGqlClient.query({
              query: GET_COMPANIES_META,
            })).data.getCompaniesMeta;
          });

        if (companiesMeta) setCompanies(companiesMeta);

        // Load selected company
        if (props.editor.recipeSwitcher.hasActiveCompany) {
          const companyMeta = await mlAuthSecured<MyLabelCompanyMeta>(props.editor,
            async () => {
              return (await mleDomainGqlClient.query({
                query: GET_COMPANY_META,
                variables: {
                  companyId: props.editor.recipeSwitcher.activeCompany
                }
              })).data.getCompanyMeta;
            });

          if (companyMeta)
            setSelectedCompany(companyMeta);
        }

        setIsLoading(false);
      })();
    },
    [props.editor.recipeSwitcher.activeCompany, props.editor.recipeSwitcher.hasActiveCompany]);

  const handleSelectCompany = useCallback((item: MyLabelCompanyMeta) => {
    setSelectedCompany(item);
    props.onCompanySelect(item);
  }, [setSelectedCompany]);

  return (
    <div>
      <CompanySelect itemRenderer={ companyItemRenderer } items={ companies }
                     onItemSelect={ handleSelectCompany } filterable={ false }>
        <Button rightIcon="caret-down" loading={ isLoading }>
          {
            selectedCompany?.name || 'Seleziona un\'organizzazione'
          }
        </Button>
      </CompanySelect>
    </div>
  );
});